"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _Share = _interopRequireDefault(require("@insided/destination/icons/Share"));

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

var _XSocial = _interopRequireDefault(require("@insided/shared/icons/XSocial"));

var _Facebook = _interopRequireDefault(require("@insided/shared/icons/Facebook"));

var _LinkedIn = _interopRequireDefault(require("@insided/shared/icons/LinkedIn"));

var _classnames = _interopRequireDefault(require("classnames"));

var openInNewTab = function openInNewTab(url) {
  globalThis.open(url, '_blank', 'noopener,noreferrer');
};

var SocialsList = function SocialsList() {
  var currentUrl = globalThis.location.hostname + globalThis.location.pathname;
  return (0, _preact.h)("div", {
    className: "topic-share__socials-list"
  }, (0, _preact.h)(_phrase.default, {
    p: "twitter.share.title",
    renderAsText: true
  }, function (twitterPhrase) {
    return (0, _preact.h)(_SubtleButton.default, {
      size: "medium",
      ariaLabel: twitterPhrase,
      className: (0, _classnames.default)('btn__icon', 'btn-x', 'qa-button-twitter'),
      icon: (0, _preact.h)(_XSocial.default, null),
      onClick: function onClick() {
        return openInNewTab("http://twitter.com/intent/tweet?text=https://".concat(currentUrl));
      }
    });
  }), (0, _preact.h)(_phrase.default, {
    p: "facebook.share.title",
    renderAsText: true
  }, function (facebookPhrase) {
    return (0, _preact.h)(_SubtleButton.default, {
      size: "medium",
      ariaLabel: facebookPhrase,
      className: (0, _classnames.default)('btn__icon', 'btn-facebook', 'qa-button-facebook'),
      icon: (0, _preact.h)(_Facebook.default, null),
      onClick: function onClick() {
        return openInNewTab("https://www.facebook.com/sharer/sharer.php?u=https://".concat(currentUrl));
      }
    });
  }), (0, _preact.h)(_phrase.default, {
    p: "linkedin.share.title",
    renderAsText: true
  }, function (linkedinPhrase) {
    return (0, _preact.h)(_SubtleButton.default, {
      size: "medium",
      ariaLabel: linkedinPhrase,
      className: (0, _classnames.default)('btn__icon', 'btn-linkedin', 'qa-button-linkedin'),
      icon: (0, _preact.h)(_LinkedIn.default, null),
      onClick: function onClick() {
        return openInNewTab("https://www.linkedin.com/shareArticle?mini=true&url=https://".concat(currentUrl));
      }
    });
  }));
};

var Share = function Share() {
  return (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    tooltipMessage: (0, _preact.h)(SocialsList, null),
    customClasses: "topic-share__tooltip",
    trigger: (0, _preact.h)(_SubtleButton.default, {
      size: "medium",
      className: "action-btn--share",
      startIcon: (0, _preact.h)(_Share.default, {
        width: 16,
        height: 16
      }),
      title: (0, _preact.h)(_phrase.default, {
        p: "Share"
      })
    })
  });
};

var _default = Share;
exports.default = _default;